interface UsePhoneVerificationParams {
	countDownElement: Ref<HTMLElement | null>;
}

interface UsePhoneVerificationReturn {
	pauseCountdown: () => void;
	resumeCountdown: () => void;
	resetCountdown: (timesSent?: number) => void;
	isIntervalActive: Ref<boolean>;
	countdownText: Ref<string>;
}

const countdownTimeDictionary: Record<number, number> = {
	0: 30,
	1: 60,
	2: 120
};

function getFormattedTime(time: number): string {
	const minutes = Math.floor(time / 60)
		.toString()
		.padStart(2, '0');
	const seconds = (time % 60).toString().padStart(2, '0');

	return `(${minutes}:${seconds})`;
}

export function usePhoneVerification(
	params: UsePhoneVerificationParams
): UsePhoneVerificationReturn {
	const { countDownElement } = params;

	const timesSent = ref<number>(0);

	const countDownTime = computed<number>(
		() => countdownTimeDictionary?.[timesSent.value] || 120
	);

	const countdown = ref<number>(countDownTime.value);

	const countdownText = computed<string>(() =>
		getFormattedTime(countdown.value)
	);

	function resetCountdown(newTimesSent?: number) {
		if (newTimesSent || newTimesSent === 0) {
			timesSent.value = newTimesSent;
		} else {
			timesSent.value++;
		}

		countdown.value = countDownTime.value;
	}

	const {
		pause,
		isActive: isIntervalActive,
		resume
	} = useInterval(1000, {
		controls: true,
		immediate: false,
		callback: () => {
			if (!countDownElement.value) return;

			countDownElement.value.innerHTML = getFormattedTime(countdown.value);

			if (countdown.value <= 0) {
				pause();
				return;
			}

			countdown.value--;
		}
	});

	return {
		countdownText,
		pauseCountdown: pause,
		resumeCountdown: resume,
		resetCountdown: resetCountdown,
		isIntervalActive
	};
}
